export class FileData {
  id: number;
  linkedId: number;
  physicalFileName: string;
  displayFileName: string;
  fileSection: number;
  fileType: number;
  contentType: string;
  contentDisposition: string;
  fileContent: string;
  fileLocation: string;
}

// If you change these, remember to change them in the Coega.Common/Enums/FileHandlerEnums.cs file as well!

export enum FileSection {
  Document = 1,
  Media = 2,
  PageContent = 3,
  PageContentBanner = 4,
  Gallery = 5,
  Newsletter = 6,
  Tender = 7,
  MediaEnquiry = 8,
  CareerApply = 9,
  Investors = 10
}

export enum FileType {
  Image = 1,
  Document = 2,
  Video = 3
}
